import { LegalLayout } from "./legal-layout";
import { LegalSection } from "./legal-section";
import { LAST_UPDATED, CONTACT_EMAIL } from "./constants";

export function TermsPage() {
  return (
    <LegalLayout title="Условия за ползване" lastUpdated={LAST_UPDATED}>
      <p>
        Добре дошли! С достъпа и използването на тази игра (наричана по-нататък
        „Услугата“) Вие приемате настоящите Условия за ползване. Ако не сте
        съгласни с тях, моля не използвайте Услугата.
      </p>

      <LegalSection heading="1. Използване на Услугата">
        <p>
          Услугата представлява безплатна игра с думи. Предоставя се „както е“,
          за лична и нетърговска употреба. Съгласявате се да не злоупотребявате с
          Услугата и да не нарушавате нейната нормална работа.
        </p>
      </LegalSection>

      <LegalSection heading="2. Акаунти">
        <p>
          За част от функциите може да е необходимо влизане чрез Google. Вие
          носите отговорност за дейностите, извършени чрез Вашия акаунт.
        </p>
      </LegalSection>

      <LegalSection heading="3. Интелектуална собственост">
        <p>
          Цялото съдържание, дизайн и код на Услугата са собственост на нейните
          създатели. Не се разрешава копиране или разпространение без съгласие.
        </p>
      </LegalSection>

      <LegalSection heading="4. Ограничаване на отговорността">
        <p>
          Услугата се предоставя без гаранции. Не носим отговорност за загуби или
          вреди, произтичащи от използването или невъзможността за използване на
          Услугата.
        </p>
      </LegalSection>

      <LegalSection heading="5. Промени">
        <p>
          Запазваме си правото да актуализираме настоящите Условия по всяко
          време. Продължаването на ползването след промени означава съгласие с
          тях.
        </p>
      </LegalSection>

      <LegalSection heading="6. Контакт">
        <p>
          За въпроси относно тези Условия: <a className="underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
